import React from 'react';
import {find} from 'lodash'

/* Utils */
import {HTTP_STATUS_CODES} from '../../common/network/httpConstants';

/* Components */
import VoltranFragment from '../../components/VoltranFragment/VoltranFragment';

function getMandatoryComponents(components) {
  return components.filter(component => {
    return component.isMandatory;
  });
}

function isExistAllMandatoryFragments(fragments, fragmentsOptions) {
  const mandatoryComponents = getMandatoryComponents(fragmentsOptions);
  for (let i = 0; i < mandatoryComponents.length; i++) {
    const searchTerm = '/' + mandatoryComponents[i].url;
    if (!find(fragments, {data: {activeComponent: {resultPath: searchTerm}}})) {
      return false;
    }
  }
  return true;
}

function isExistPartialFragment(fragments) {
  if (fragments?.length > 0) {
    for (let i = 0; i < fragments?.length; i++) {
      const fragment = fragments[i];
      if (fragment?.result?.status === HTTP_STATUS_CODES.PARTIAL_CONTENT) {
        return true;
      }
    }
  }
  return false;
}


function renderFragments(fragmentsMap, fragmentsOptions, renderMethodClientSide) {
  if (fragmentsMap.size === 0 || !fragmentsOptions?.length) {
    return null;
  }

  return fragmentsOptions.map((options, index) => {
    const fragment = fragmentsMap.get(options.id.toString());

    if (fragment) {
      return (
        <VoltranFragment
          key={index}
          fragmentInfo={fragment}
          options={options}
          renderMethodClientSide={renderMethodClientSide} />
      );
    }
    return null;
  });
}

function getHerouselPreloadedImage(fragmentsMap, homePageComponents) {
  const herouselId = homePageComponents?.find((cmp) => cmp.componentTypeName === 'Herousel')?.id?.toString()
  const herouselFragment = fragmentsMap.get(herouselId)

  return herouselFragment?.seoState?.preloadedImageSrc
}

export {
  isExistAllMandatoryFragments,
  isExistPartialFragment,
  renderFragments,
  getHerouselPreloadedImage,
}
